<template>
  <range
    :label="$t('edit.sidebar.font_size')"
    min="12"
    max="32"
    step="1"
    :value="value()"
    :change="onChange"
    :move="onMove"
  ></range>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Range from '../../../general/Range.vue';

const defaultValue = 18;

export default {
  components: {
    Range,
  },
  methods: {
    value() {
      if (!this.boxConfig.trigger_button.style.fontSize) {
        return defaultValue;
      }

      return this.boxConfig.trigger_button.style.fontSize.replace('px', '');
    },
    onChange(value) {
      this.boxUpdateConfigStyle({
        item: 'trigger_button',
        rule: 'fontSize',
        value: `${value}px`,
      });
    },
    onMove(value) {
      this.boxPreviewConfigStyleChange({
        item: 'trigger_button',
        rule: 'fontSize',
        value: `${value}px`,
      });
    },
    ...mapActions([
      'boxUpdateConfigStyle',
      'boxPreviewConfigStyleChange',
    ]),
  },
  computed: mapGetters({
    boxConfig: 'boxConfig',
  }),
};
</script>



/** WEBPACK FOOTER **
 ** FontSize.vue?1c702566
 **/